export const tabsNav = {
    partners: {
        id: 'partners',
        name: 'Партнерские предложения',
        template: 'partners',
        pathName: 'partners',
        icon: 'briefcase',
        iconSize: '15',
    },
    partnerGroups: {
        id: 'partnerGroups',
        name: 'Группы партнерских предложений',
        template: 'partnerGroups',
        pathName: 'partnerGroups',
        icon: 'briefcase',
        iconSize: '15',
    },
};
